import request from '@/util/request'
import auth from '@/util/auth'
import config from '@/config'
const state = {
  accessToken: '',
  account: '',
  roleId: '',
  userType:null,

  isSupervisor: null,
  isCompany: null,
  isAdmin: null,
  isIndie:null,
  isAC:null,
  isAS:null,
  isASS:null,
  isACS:null,
  isPartner:null,
  subjectId:null,
  subject:{},
  menu: [],
  userinfo:{}
}

const mutations = {
  setMenu: (state, data) => {
    //转换菜单结果 并保存 权限
    state.menu = auth.setMenu(data)
  },

  setSession: (state, data) => {
    auth.setSession(data)
    state.accessToken = data.accessToken
    state.account = data.account
  },

  clearSession:(state , data)=>{
    auth.removeSession()
    state.accessToken = ''
    state.account = ''
    state.menu = []
    state.isSupervisor = false
    state.isAdmin = false
    state.isCompany = false
    state.isIndie = false
    state.isAC = false
    state.isAS = false
    state.isACS = false
    state.subject = {}
    state.subjectId = null
  },

  setUserInfo:(state , data) => {
    state.userinfo = data

    // userType：0、商城系统用户，1、考试系统，网点用户，2、考试系统：监管用户, 3. LSP系统：平台管理人员,4、LSP系统：监管人员, 5、LSP系统：网点企业人员,6、LSP系统:快递员(courier),7、LSP系统：维修站点管理员，8、LSP系统：维修站点-维修师(repair_user) , 9、LSP系统：合作企业用户
    // attributes : 1 个人 ,2 企业
    state.userType = data.userType
    state.isAdmin = data.userType == 3
    state.isSupervisor = data.userType == 4
    state.isCompany = data.userType == 5 && data.attributes == 2
    state.isIndie = data.userType == 5 && data.attributes == 1
    state.isAC = state.isAdmin || state.isCompany
    state.isAS = state.isAdmin || state.isSupervisor
    state.isACS = state.isAdmin || state.isCompany || state.isSupervisor
    state.isASS = data.userType == 7
    state.isPartner = data.userType == 9
    
    if(state.isAdmin){
      state.subjectId = data.id
      state.subject = data
    }else if(state.isCompany){
      if(data.companys && data.companys.length){
        state.subjectId = data.companys[0].id
        state.subject = data.companys[0]
      }
    }else if(state.isSupervisor){
      state.subjectId = data.orgVO ? data.orgVO.id : null
      if(state.subjectId){
        state.subject = data.orgVO
      }
    }else if(state.isASS){
      state.subjectId = data.id
      state.subject = data
    }else if(state.isPartner){
      state.subjectId = data.id
      state.subject = data
    }

    // 3 系统管理 4 监管 5 企业 7 维修站点管理员
    state.userRole = data.userType == 3 ? 0 : data.userType == 4 ? 1 : 2
    auth.setUserInfo({userRole:state.userRole , userType:data.userType})
  }
}

const actions = {

  signin({ commit }, data) {
    return new Promise((resolve) => {
      request.signin(data).then(({headers , data:resp}) => {
        if (resp.code == 0) {
          let token = headers.authorization
          commit('setSession', {
            accessToken:token,
            account:data.account,
          })
        }
        resolve(resp)
      }).catch((e)=>{
        resolve({code:-1})
      })
    })
  },

  // 登出
  signout({ commit }) {
    return new Promise((resolve) => {
      request.signout().then(resp => {
        commit('clearSession', '')
        resolve(resp)
      })
    })
  },


  status({commit}){
    return new Promise(resolve => {
      // 0 未登录 无 token
      // 1 已登录 有 token
      // 2 未登录 有 token
      let code = auth.getStatus()
        
      if( code === 0 ){
        resolve(0)
      }
      else if( code === 2 ){
        commit('setSession', auth.getSession())
        if( config.dev ){
          commit("setMenu", auth.getLocalMenu())
          request.userinfo().then(resp => {
            if (resp.code == 0) {
              commit('setUserInfo', resp.data)
              resolve(2)
            }
          }).catch((e) => {
            resolve(0)
          })
          return
        }
        //获取菜单
        request.menus().then(res => {
          if (res.code == 0) {
            commit("setMenu", res.data)
            // resolve(2)
            request.userinfo().then(resp => {
              if (resp.code == 0) {
                commit('setUserInfo', resp.data)
                resolve(2)
              }
            }).catch((e) => {
              resolve(0)
            })

          }
          //未登录
          else if( res.code == 100000 ){
            auth.removeSession()
            resolve(0)
          }else{
            resolve(0)
          }
        })
      }
      else if( code === 1 ){
        resolve(1)
      }
      else{
        resolve(1)
      }
      
    })
  },

  userinfo({commit}){
    request.userinfo().then(resp => {
      if (resp.code == 0) {
        commit('setUserInfo', resp.data)
      }
    }).catch((e) => {
      resolve({ code: -1 })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
